// removed by extract-text-webpack-plugin
module.exports = {"PageHeader":"_2DavkWbhS79si5YZ6j2Ur6","PageTitle":"_22NEC6HuAfA4OszfapxHlu","PageSubtitle":"g7m1r6-nqazyYBzHR0c9P","MobileFiltersToggle":"jFFG5OTJz_5hSWMRRRhG5","Card":"_2BKkOicyFaKzFYrqY0q2qC","PaginationWrap":"_1E-OqnD4xcjqSBzKKNb1-6","PaginationItem":"_3RQvrUpBzdBWPfJpP8xUfA","PaginationLink":"_1QzVQG0LdYccxHu5Lhmwbv","PaginationActive":"_MMTziaw7nVDBWv8Iuzu5","Summary":"_1U55iSUOJRwYxl8tD78Jvw"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfAdministrator/AdminAudit/styles.module.css
// module id = 604
// module chunks = 0